/****************************************************
ChemicalDataUpload.tsx - Chemical upload  component for admin
*****************************************************/
import React, { useState } from 'react';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import '../Admin.scss';
import Loader from "../../../../common/Loader/Loader";
import Modal from 'react-bootstrap/Modal';
import { reloadApp } from "../../../../common/functions/utils";
import { fetchAPI, METHODS } from "../../../../../helper/functions/axios";
import { kclRootState } from "../../../../../store/gloveSelectorStore";
import { chemicalFile} from "../../../../../types/allTypes";

const ChemicalDataUpload = () => {
    const { t } = useTranslation();
    const { CHEMICHAL_UPLOAD_MAX_FILESIZE, API_PATHS, PAGE_NAVIGATION, ERROR_MESSAGES,CHEMICHAL_UPLOAD_FILE_TYPES } = useSelector((state: kclRootState) => state?.glovesSelector?.config || {});
    const [file, setFile] = useState<chemicalFile>(null);
    const [warning, setWarning] = useState<string>("");
    const [uploadStatus, setuploadStatus] = useState<string>("");
    const [uploadInProgress, setUploadInProgress] = useState<boolean>(false);
    const [isUploadSucces, setIsUploadSucces] = useState<boolean>(false);
    const closeWarning = () => setuploadStatus("");
    const handleUpload = () => {
        const newFile = file;
        const fileNotMatch = newFile && (!CHEMICHAL_UPLOAD_FILE_TYPES?.includes(newFile?.type) || uploadInProgress || newFile?.size < 1 || newFile?.size >= CHEMICHAL_UPLOAD_MAX_FILESIZE)
        const fileMatch = newFile && (newFile?.size > 0 && newFile?.size < CHEMICHAL_UPLOAD_MAX_FILESIZE);
        //checking for empty file
        if (fileNotMatch) {
            return;
        }
        else if (fileMatch) {
            setUploadInProgress(true);
            const formData = new FormData();
            formData.append("file", file);
            fetchAPI(METHODS.POST, API_PATHS.CHEMICAL_FILE_UPLOAD, formData).then(response => {
                const message = response?.data?.message || {};
                setFile(null);
                if (message?.isSuccess) {
                    setIsUploadSucces(true);
                    setuploadStatus(message?.result?.message || t("ChemicalUpload.FileUploadSuccessMessage"));
                }
                else {
                    setIsUploadSucces(false);
                    //error details
                    const result = message?.result || {};
                    if (result?.error === ERROR_MESSAGES.INVALID_TOKEN) {
                        //redirecting to login page 
                        reloadApp(API_PATHS.GET_USER_LOGIN + PAGE_NAVIGATION.ADMIN_DASHBOARD);
                    }
                    else {
                        setuploadStatus(`${result?.error}`);
                    }
                }
                setUploadInProgress(false);
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            }).catch(error => {
                setFile(null);
                setuploadStatus(t("ChemicalUpload.FileUploadCommonErrorMessage"));
                setUploadInProgress(false);
            });
        }
    };
    //cancel click
    const handleCancel = () => {
        if (uploadInProgress) {
            return;
        }
        setFile(null);
    };
    //on file input chnage 
    const handleOnChange = (e) => {
        setuploadStatus("");
        const newFile = e.target.files[0];
        const fileSizeInRange = newFile?.size < CHEMICHAL_UPLOAD_MAX_FILESIZE;
        //checking for empty file
        if (newFile?.size < 1) {
            setWarning(t("ChemicalUpload.EmptyFile"));
            return;
        } 
        else if (!CHEMICHAL_UPLOAD_FILE_TYPES?.includes(newFile?.type)) {
            setWarning(t("ChemicalUpload.FileFormatMismatch"));
            return;
        }//checking max size exceeds
        else if (newFile?.size > CHEMICHAL_UPLOAD_MAX_FILESIZE) {
            setWarning(t("ChemicalUpload.FileSizeExeed"));
            return;
        }
        else if (newFile?.size > 0 && fileSizeInRange ) {
            setFile(newFile);
            e.target.value = null;
            setWarning("");
        }
    };
    return (
        <>
            <div className='gloves-admin border-bottom'>
                <div className='main-title'>
                    <div className="textstart">
                        <div className='heading'>{t("ChemicalUpload.Heading")} </div>
                    </div>
                </div>
                <div className="row">
                    <div className="upload-files">
                        <div className='sub-heading'>{t("ChemicalUpload.SelectFile")}</div>
                        <div className="input input-file">
                            <div className="button">
                                <input type="file" id="inputGroupFile01" accept=".csv" className="custom-file-input" onChange={handleOnChange} /> Browse
                            </div>
                            <input type="text" className="form-control form-control-sm" placeholder={(file && file?.name?.length > 0) ? file?.name : ""} />
                            <div>{warning?.length > 0 && <span className='custom-file-error-message'>{warning}</span>}</div>
                        </div>
                        <p>{t("ChemicalUpload.MaxSizeInfo")}</p>
                        <div className='cta-btns mb-5'>
                            <div className={file && file?.name?.length > 0 ? "button button-primary" : "button button-disabled"} onClick={handleUpload}>{uploadInProgress ? <Loader customClass="spinner-border spinner-border-sm" /> : t("ChemicalUpload.UploadData")}</div>
                            <div onClick={handleCancel} className={(file && file?.name?.length > 0) || uploadInProgress ? "button button-outline" : "button button-disabled"}>{t("ChemicalUpload.Cancel")}</div>
                        </div>
                        {uploadStatus?.length > 0 && <div> <p>{uploadStatus}</p></div>}
                    </div>
                </div>
            </div>
            <Modal show={uploadStatus?.length > 0} onHide={closeWarning} animation={false} aria-labelledby="MaxFilterWarning" centered className="facet-maxfilter-modal">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <div className="filters-alert">
                            {isUploadSucces ? 'Data Upload Successful!' : 'Data Upload Failure!'}
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="mx-2">
                    <div className="row mx-0">
                        <div className={isUploadSucces ? 'alert alert-success' : 'alert alert-danger'} role="alert">
                            {uploadStatus}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};
export default ChemicalDataUpload;